import type { EntityApi, EntityEndpoints, PaginatedResponse } from '@/shared/types/entity';
import { api } from './index';
import { normalizePaginatedResponse } from './pagination';
import type { PaginatedApiResponse } from './pagination';

export class BaseApi<T, D> implements EntityApi<T, D> {
  private endpoints: EntityEndpoints;

  constructor(endpoints: EntityEndpoints) {
    this.endpoints = endpoints;
  }

  async getList(params?: {
    perPage?: number;
    page?: number;
    search?: string;
  }): Promise<PaginatedResponse<T>> {
    const response = await api.get<PaginatedApiResponse<T>>(this.endpoints.LIST, {
      params,
    });
    return normalizePaginatedResponse(response.data);
  }

  async getOne(id: number): Promise<T> {
    const response = await api.get<T>(this.endpoints.SHOW(id.toString()));
    return response.data;
  }

  async create(data: D): Promise<T> {
    const response = await api.post<T>(this.endpoints.CREATE, data);
    return response.data;
  }

  async update(id: number, data: Partial<D>): Promise<T> {
    const response = await api.put<T>(this.endpoints.UPDATE(id.toString()), data);
    return response.data;
  }

  async delete(id: number): Promise<void> {
    await api.delete(this.endpoints.DELETE(id.toString()));
  }
}
